<div class="nebenantraege-tab">
    <ng-container *ngIf="displayedNebenantragsarten$ | async as displayedNebenantragsarten">
        <ng-container *ngIf="displayedNebenantragsarten.length > 0; else noDataTemplate">
            <ng-container *ngFor="let displayedNebenantragsart of displayedNebenantragsarten">
                <button
                    class="nebenantraege-tab__art"
                    (click)="navigateToNebenantragsDetails(displayedNebenantragsart)"
                    [attr.data-testid]="'nebenantragsart-' + displayedNebenantragsart.id">
                    <app-card>
                        <div class="nebenantraege-tab__art__button-card">
                            <p
                                class="text-accordeon-card-title"
                                style="width: 25%; text-align: left; color: var(--color-accent-primary);">
                                {{ displayedNebenantragsart.bezeichnung }}
                            </p>
                            <img
                                src="/assets/images/svgs/arrow-right-thin.svg"
                                class="nebenantraege-tab__art__button-card__svg"
                                alt="Pfeil rechts"
                            />
                            <p
                                class="text-plain"
                                style="width: 30%; color: var(--color-accent-primary);">
                                Anzahl bisheriger Nebenanträge: {{ displayedNebenantragsart.amount }}
                            </p>
                            <app-button
                                class="nebenantraege-tab__button"
                                [isButton]="true"
                                (clickEvent)="$event.stopPropagation(); navigateToFormular(displayedNebenantragsart)"
                                [buttonLabel]="getNewAntragLabel(displayedNebenantragsart)"
                                data-testid="create-nebenantrag-button"
                                [disabled]="!((nebenantragsartenCreateableIds$ | async)?.includes(displayedNebenantragsart.id) ?? false)"></app-button>
                        </div>
                    </app-card>
                </button>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
<ng-template #noDataTemplate>
    <div class="nebenantraege-tab__art__no-data">
        <h2 class="nebenantraege-tab__art__no-data--empty">Es sind keine Nebenanträge vorhanden.</h2>
    </div>
</ng-template>
